export default {"src":"/_next/static/media/live-auction.0bf243de.svg","height":24,"width":24};